export default {
  title: {
    id: 'checkout_step_addresses_shipping_title',
    defaultMessage: 'Shipping address',
  },
  edit: {
    id: 'checkout_step_addresses_shipping_edit',
    defaultMessage: 'Edit address',
  },
}
